import React from "react";
import MSelect, { MSelectOption } from "components/Shared/MSelect.tsx";
import { SelectionControl } from "react-md";

interface CustomerSurveyTypeSelection {
  onCustomerChange: (option: MSelectOption) => void;
  customerOptions: MSelectOption[];
  selectedCustomer: MSelectOption;
  onSurveyTypeChange: (option: MSelectOption) => void;
  surveyTypeOptions: MSelectOption[];
  selectedSurveyType: MSelectOption;
  confirmedSelection: boolean;
  onConfirmSelection: (value: boolean) => void;
  destinationCustomer: string;
}

const CustomerSurveyTypeSelection = (props: CustomerSurveyTypeSelection) => {
  const getCustomerPortalTarget = () => document.querySelector("copy-survey-type-customer-dropdown");
  const getSurveyTypePortalTarget = () => document.querySelector("copy-survey-type-dropdown");

  return (
    <div>
      <div>
        <p>Select Customer Account:</p>
        <MSelect
          className="copy-survey-type-customer-dropdown"
          key="copy-survey-type-customer-dropdown"
          label="Select Customer Account"
          placeholder="Select Account..."
          isClearable={false}
          enableAllOption={false}
          onChange={props.onCustomerChange}
          options={props.customerOptions}
          value={props.selectedCustomer}
          getMenuPortalTarget={getCustomerPortalTarget}
        />
      </div>
      {props.selectedCustomer && <div>
        <p>Select Survey Type to Copy:</p>
        <MSelect
          className="copy-survey-type-dropdown"
          key="copy-survey-type-dropdown"
          label="Select Survey Type"
          placeholder="Select Survey Type..."
          isClearable={false}
          enableAllOption={false}
          onChange={props.onSurveyTypeChange}
          options={props.surveyTypeOptions}
          value={props.selectedSurveyType}
          getMenuPortalTarget={getSurveyTypePortalTarget}
        />
      </div>}
      {props.selectedSurveyType && 
        <SelectionControl
        id="assign-appointment-dialog-send-confirmation"
        label={`Check to confirm you want to copy ${props.selectedSurveyType.label} from account ${props.selectedCustomer.label} to account ${props.destinationCustomer}`}
        type="checkbox"
        onChange={props.onConfirmSelection}
        value={`${props.confirmedSelection}`}
        name="Confirm Selection"
      />}
    </div>
  );
};

export default CustomerSurveyTypeSelection